import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import {TranslateService} from './translate/translate.service';
import {StorageService} from './storage/storage.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {CredentialsInterceptor} from '../auth/services/credentials.interceptor';
import { ResilienceInterceptor } from './interceptors/resilience.interceptor';
import localeEN from '@angular/common/locales/en';
import localePL from '@angular/common/locales/pl';
import { RouterModule } from '@angular/router';



export function setupTranslateFactory(service: TranslateService): Function {
  const storage = new StorageService();
  const lang = storage.get('currentUser') ? storage.get('currentUser').language : 'pl';
  return () => service.use(lang);
}

registerLocaleData(localeEN, 'en');
registerLocaleData(localePL, 'pl');

@NgModule({
  imports: [
    RouterModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [TranslateService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CredentialsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResilienceInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
      parentModule: CoreModule
  ) {
    // Import guard
    if (parentModule) {
      throw new Error(
        `${parentModule} has already been loaded. Import Core module in the AppModule only.`
      );
    }
  }
}
